import React from "react";

const PERSONA_TONES = {
    student: "border-klareet-BLUE/40 text-klareet-BLUE bg-klareet-BLUE/10",
    professional:
        "border-klareet-T/40 text-klareet-T2 bg-klareet-T/10",
    career_services:
        "border-klareet-PURPLE/40 text-klareet-PURPLE bg-klareet-PURPLE/10",
    employer:
        "border-klareet-AMBER/40 text-klareet-AMBER bg-klareet-AMBER/10",
};

const PAIN_TONES = {
    direction: "border-klareet-T/40 text-klareet-T2 bg-klareet-T/10",
    stuck: "border-klareet-RED/40 text-klareet-RED bg-klareet-RED/10",
    confidence: "border-klareet-PURPLE/40 text-klareet-PURPLE bg-klareet-PURPLE/10",
    external: "border-klareet-AMBER/40 text-klareet-AMBER bg-klareet-AMBER/10",
    none: "border-klareet-bor text-klareet-MUT bg-klareet-card",
};

const WAITLIST_TONES = {
    yes_pay: "border-klareet-GREEN/50 text-klareet-GREEN bg-klareet-GREEN/10",
    yes_free: "border-klareet-T/40 text-klareet-T2 bg-klareet-T/10",
    maybe: "border-klareet-AMBER/40 text-klareet-AMBER bg-klareet-AMBER/10",
    no: "border-klareet-bor text-klareet-MUT bg-klareet-card",
};

const HUMANIZE = {
    student: "Student",
    professional: "Professional",
    career_services: "Counsellor",
    employer: "Employer",
    direction: "Direction",
    stuck: "Stuck",
    confidence: "Confidence",
    external: "External",
    none: "None",
    yes_pay: "Yes (paid)",
    yes_free: "Yes (free)",
    maybe: "Maybe",
    no: "Not now",
};

export function Pill({ value, kind = "persona" }) {
    if (!value) return <span className="text-klareet-DIM text-xs">—</span>;
    const tones =
        kind === "persona"
            ? PERSONA_TONES
            : kind === "pain"
              ? PAIN_TONES
              : WAITLIST_TONES;
    const cls = tones[value] || "border-klareet-bor text-klareet-MUT bg-klareet-card";
    return (
        <span
            className={`inline-flex items-center px-2.5 py-1 rounded-full border text-[11px] font-medium ${cls}`}
        >
            {HUMANIZE[value] || value}
        </span>
    );
}
